// eslint-disable-next-line react/prop-types
export const Container = ({ children }) => (
  <div className='container'>
    {children}
  </div>
);
